
export const RELEASE_NOTES_REQUEST = 'RELEASE_NOTES_REQUEST';
export const RELEASE_NOTES_SUCCESS = 'RELEASE_NOTES_SUCCESS';
export const RELEASE_NOTES_FAILURE = 'RELEASE_NOTES_FAILURE';

const requestReleaseNotes = () => ({
	type: RELEASE_NOTES_REQUEST
});

const receiveReleaseNotes = (json) => ({
	type: RELEASE_NOTES_SUCCESS,
	payload: json
});

const releaseNotesError = () => ({
	type: RELEASE_NOTES_FAILURE
});

export const loadReleaseNotes = (url) => (dispatch, getState) => {
	dispatch(requestReleaseNotes());
	return fetch(url, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
		.then(response => {
			if (response.ok) {
				return response.json().then(json => {
					dispatch(receiveReleaseNotes(json));
				});
			} else {
				dispatch(releaseNotesError());
			}
		});
};